// eslint-disable-next-line jira/filename-case
import React, { Component, type ReactNode } from 'react';
import { stopLowPriorityEventDelay } from '@jira/platform__observability-event-delay-controller/src/index.tsx';
import { isAutomaticExposureCollectionEnabled } from '@jira/platform__observability-track-all-changes-sampling';
import StartApdexMountMark from '@jira/platform__op-triggers/src/on-mount-and-update/OpTrigger.tsx';
import clearMarksWithPrefix from '@jira/platform__performance/src/clear-marks-with-prefix.tsx';
import { setMark } from '@jira/platform__performance/src/marks.tsx';
import { performanceKeyPrefix, SPA_APP_START } from './constants.tsx';
import Context from './spaApdexAnalyticsContext.tsx';
import type { BM3Metric } from './submit-apdex-mark/types.tsx';
import { getPrefixedMarkName } from './transform.tsx';

type Props = {
	children: ReactNode;
	pageId: string;
};

// oxlint-disable-next-line react/prefer-function-component
export default class Provider extends Component<Props> {
	customMarks: never[] = [];

	onStart = (): void => {
		clearMarksWithPrefix(performanceKeyPrefix);
		setMark(SPA_APP_START);
	};

	onCustomMark = (markName: string): void => {
		setMark(getPrefixedMarkName(markName));
		// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
		this.customMarks.push(markName);
	};

	onReady = (
		metricKeyForInitialRender: string,
		metricKeyForTransition: string,
		extra: {
			[key: string]: number | string | boolean;
		} = {},
		metric: BM3Metric,
	): void => {
		metric.stop({ customData: extra });

		if (isAutomaticExposureCollectionEnabled()) {
			stopLowPriorityEventDelay();
		}
	};

	render(): React.JSX.Element {
		const { children, pageId } = this.props;

		return (
			<Context.Provider
				// @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
				value={{
					pageId,
					onReady: this.onReady,
					onCustomMark: this.onCustomMark,
				}}
			>
				<>
					{/* @ts-expect-error - TS2769 - No overload matches this call. */}
					<StartApdexMountMark op={this.onStart} args={[pageId]} />
					{children}
				</>
			</Context.Provider>
		);
	}
}
